import * as React from 'react';
import { useSelector } from 'react-redux';

// Components
import DisclaimerPopupBase from './DisclaimerPopupBase';
import { InjectReducerContext } from '@shopee/with-inject-reducer';

// Redux
import {
  martSearchItemsReducer,
  getMartSearchResult,
  MartSearchItemsStore,
} from '@shopee/mart-search-items-redux';
import { MART_SEARCH_ITEMS_REDUX_KEY } from '@shopee/rw-search-redux-keys';

// Types
import type { SearchParams } from '@shopee/search-common-util';

type Props = {
  searchParams: SearchParams;
};

const MartDisclaimerPopup = ({ searchParams }: Props) => {
  const { injectAsyncReducer } = React.useContext(InjectReducerContext);

  React.useEffect(() => {
    injectAsyncReducer({
      [MART_SEARCH_ITEMS_REDUX_KEY]: martSearchItemsReducer,
    });
  }, [injectAsyncReducer]);

  const originalSearchParams =
    searchParams.keyword || searchParams.complementKeyword
      ? {
          ...searchParams,
          keyword: searchParams.complementKeyword,
        }
      : void 0;
  const disclaimerInfo = useSelector((state: Record<string, unknown>) => {
    const store = state[MART_SEARCH_ITEMS_REDUX_KEY] as MartSearchItemsStore;
    const searchResult = getMartSearchResult(
      store,
      originalSearchParams || searchParams
    );
    return searchResult && searchResult.disclaimer_infos;
  });

  return (
    <DisclaimerPopupBase
      disclaimerInfo={disclaimerInfo}
      searchParams={searchParams}
      originalSearchParams={originalSearchParams}
    />
  );
};

export default MartDisclaimerPopup;
